import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { ChromePicker } from 'react-color'
import { Form, Button, Alert, Icon } from 'antd'
import { userColorChange } from '../../actions/AuthAction'
import './change-color.css'

export class ChangeColor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      colorState: '',
      btnFrom: ''
    }
  }

  componentDidMount() {
    const { newColor } = this.props
    this.setState({
      colorState: newColor
    })
  }

  handleChangeComplete = color => {
    this.setState({
      colorState: color.hex
    })
  }

  handleOnClick = () => {
    const { colorState } = this.state;
    const rootStyles = document.documentElement.style;
    localStorage.setItem('primaryColor', colorState);
    rootStyles.setProperty('--primary-color', colorState, "important");
    this.setState({
      btnFrom: 'change'
    }, () => this.props.userColorChange(colorState))
  }

  handleRestoreColor = () => {
    this.setState({
      colorState: '#2E97CF',
      btnFrom: 'restore'
    }, () => this.props.userColorChange('#2E97CF'))
  }


  render() {
    const { colorState, btnFrom } = this.state
    const { newColor, isFetching, intl } = this.props

    return (
      <React.Fragment>
        <Form.Item className='config-title' >
          <span>{intl.formatMessage({ id: "select_color" })} </span>
        </Form.Item>
        <Form.Item>
          <Alert
            message={intl.formatMessage({ id: "warning" })}
            description={intl.formatMessage({ id: "select_color_warning" })}
            type="warning"
            className='color-alert'
            showIcon />
        </Form.Item>
        <Form.Item>
          <ChromePicker
            disableAlpha={true}
            className='color-picker'
            color={colorState}
            onChangeComplete={this.handleChangeComplete} />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            loading={btnFrom === 'change' && isFetching}
            style={{ backgroundColor: newColor, borderColor: newColor }}
            onClick={this.handleOnClick}>{intl.formatMessage({ id: "change" })}</Button>
          <Button
            type="primary"
            loading={btnFrom === 'restore' && isFetching}
            style={{ marginLeft: '10px', backgroundColor: '#2E97CF', borderColor: '#2E97CF' }}
            onClick={this.handleRestoreColor}>{intl.formatMessage({ id: "reset" })}</Button>
          <Button
            type="default"
            style={{ marginLeft: '10px', color: newColor, borderColor: newColor }}
            onClick={this.props.handleHideColor}>{intl.formatMessage({ id: "cancel_button" })}<Icon type="close" /></Button>
        </Form.Item>
      </React.Fragment >
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    isFetching: state.authUser.isFetching
  }
}

const mapDispatchToProps = {
  userColorChange
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeColor)))